export const RADIUS_OPTIONS = (appendix: string) => [
  {
    label: `Travel Distance: 1 ${appendix.substring(0, appendix.length - 1)}`,
    value: `1`,
  },
  {
    label: `Travel Distance: 2 ${appendix}`,
    value: `2`,
  },
  {
    label: `Travel Distance: 3 ${appendix}`,
    value: `3`,
  },
  {
    label: `Travel Distance: 4 ${appendix}`,
    value: `4`,
  },
  {
    label: `Travel Distance: 5 ${appendix}`,
    value: `5`,
  },
  {
    label: `Travel Distance: 6 ${appendix}`,
    value: `6`,
  },
  {
    label: `Travel Distance: 7 ${appendix}`,
    value: `7`,
  },
  {
    label: `Travel Distance: 8 ${appendix}`,
    value: `8`,
  },
  {
    label: `Travel Distance: 9 ${appendix}`,
    value: `9`,
  },
  {
    label: `Travel Distance: 10 ${appendix}`,
    value: `10`,
  },
  {
    label: `Travel Distance: 15 ${appendix}`,
    value: `15`,
  },
  {
    label: `Travel Distance: 20 ${appendix}`,
    value: `20`,
  },
  {
    label: `Travel Distance: 25 ${appendix}`,
    value: `25`,
  },
  {
    label: `Travel Distance: 30 ${appendix}`,
    value: `30`,
  },
  {
    label: `Travel Distance: 35 ${appendix}`,
    value: `35`,
  },
];

export default RADIUS_OPTIONS;
